import { render } from "./soal_salah_benar.vue?vue&type=template&id=6657b780&scoped=true"
import script from "./soal_salah_benar.vue?vue&type=script&lang=js"
export * from "./soal_salah_benar.vue?vue&type=script&lang=js"

import "./soal_salah_benar.vue?vue&type=style&index=0&id=6657b780&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/WwEazHb5/0/pln-pusdiklat/ups/assessment_hc_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6657b780"]])

export default __exports__